import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

//Arquivos para funcionalidades de tipos de serviço
export interface NameIdService {
  nome: string;
  id: string;
  dataAdicao: number;
  dataDelecao?: number;
}

export interface ConjuntosServico extends NameIdService {
  forms?: NameIdService;
  equipesExecuta?: NameIdService;
  equipesAtende?: NameIdService;
  equipesNotifica?: NameIdService;
  chamados?: NameIdService;
}

export type types = {
  nome: string;
  dataCriacao: number;
  tipoDescicao?: string,
  tipoId: string;
  locais?: {
    [id: string]: NameIdService
  };
  clientes?: {
    [id: string]: NameIdService
  };
  notificacoes?: {
    [id: string]: NameIdService
  };
  conjuntos?: {
    [id: string]: ConjuntosServico
  };
};

export default class ServiceTypes {


  getAllByCompany = async (body: AuthBodyType & { empresa: string }) => {
    try {
      const data: AxiosResponse = await api.post("/servicesTypes/getAllByCompany", {
        ...body,
      });
      return data.data.tiposServicos;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createServiceType = async (body: AuthBodyType & { empresa: string; tipoNome?: string, descricao?: string }) => {
    try {
      const data: AxiosResponse = await api.post("/servicesTypes/createServiceType", {
        ...body,
      });
      return data.data.tiposServicos;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  editServiceType = async (
    body: AuthBodyType & {
      tipo: {
        nome: string;
        tipoId?: string;
        descricao?: string;
        dataCriacao?: number;
      };
    }
  ) => {
    try {
      const data: AxiosResponse = await api.post("/servicesTypes/editServiceType ", {
        ...body,
      });
      return data.data.tiposServicos.tipo;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  deleteServiceType = async (
    body: AuthBodyType & { empresa: string, tipoId: string }
  ) => {
    try {
      const data: AxiosResponse = await api.post("/servicesTypes/deleteServiceType", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };
}
